import { InquiryIso6391LanguageCode } from 'lib/constants/locales';
import { ApiListRelationship, ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';
import DeviceHandoffOption from 'lib/interfaces/DeviceHandoffOption';

export enum InquirySessionStatus {
  New = 'new',
  Active = 'active',
  Expired = 'expired',
}

export enum InquirySessionDeviceType {
  Desktop = 'desktop',
  Smartphone = 'smartphone',
  Tablet = 'tablet',
  Console = 'console',
  PortableMediaPlayer = 'portable media player',
  TV = 'tv',
  CarBrowser = 'car browser',
  Camera = 'camera',
}

export enum InquirySessionThreatLevel {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export enum InquirySessionIpConnectionType {
  Residential = 'residential',
  Corporate = 'corporate',
  Education = 'education',
  Mobile = 'mobile',
  Datacenter = 'datacenter',
}

// NOTE: This is distinct from DeviceHandoffOption, which specifices which handoff
// methods are configurable. Shortlink is always generated.
export type DeviceHandoffMethod = DeviceHandoffOption | 'shortlink';

export interface InquirySessionAttributes {
  status: InquirySessionStatus;
  'created-at': string;
  'started-at'?: string;
  'expired-at'?: string;
  'redacted-at'?: string;

  'ip-address'?: string;
  'browser-name'?: string;
  'browser-full-version'?: string;
  'os-name'?: string;
  'os-full-version'?: string;
  'device-name'?: string;
  'device-type'?: InquirySessionDeviceType;
  'device-handoff-method'?: DeviceHandoffMethod;

  'is-proxy'?: boolean;
  'is-tor'?: boolean;
  'is-datacenter'?: boolean;
  'is-vpn'?: boolean;
  'threat-level'?: InquirySessionThreatLevel;
  'country-code'?: string;
  'country-name'?: string;
  'region-name'?: string;
  locale?: InquiryIso6391LanguageCode;
  'gps-latitude'?: number;
  'gps-longitude'?: number;
  'gps-precision'?: 'rough' | 'precise';
  latitude?: number;
  longitude?: number;
  'ip-isp'?: string;
  'ip-connection-type'?: InquirySessionIpConnectionType;

  'distraction-events'?: number;
  'request-spoof-attempts'?: number;
  'shortcut-copies'?: number;
  'shortcut-pastes'?: number;
  'autofill-cancels'?: number;
  'autofill-starts'?: number;
}

export interface InquirySessionRelationships {
  'list-matches': ApiListRelationship<ApiModel.ListMatch>;
  device: ApiRelationship<ApiModel.Device>;
}

export type InquirySession = ApiResource<
  InquirySessionAttributes,
  InquirySessionRelationships,
  ApiModel.InquirySession
>;
